<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Aditivo -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label>Tipo Aditivo</label>
                    <label v-if="tipoAditivo == 1 || tipoAditivo == 2">
                    <b-badge variant="warning">Este aditivo somente funcionará no caso do convênio estar integrado com o RM.</b-badge>
                    </label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="tiposAditivo"
                            value-field="key"
                            text-field="label"
                            v-model="tipoAditivo"
                            :disabled='atualizar'>
                        </b-form-select>
                        <b-form-invalid-feedback>Tipo do Aditivo é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label>Objeto</label>
                    <b-input-group>
                        <b-form-textarea
                            type="text"
                            v-model="objeto"
                            placeholder="Objeto"
                            :rows="4"
                            @input.native="$v.objeto.$touch()"
                            :state="$v.objeto.$error ? false : null">
                        </b-form-textarea>
                        <b-form-invalid-feedback>Objeto é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="8">
                <b-form-group
                    v-if="exibeData"
                    :state="$v.dataProrrogada.$error ? false : null"
                    invalid-feedback="Data é obrigatória">
                    <label>Data Prorrogação</label>
                    <b-input-group>
                        <date-picker
                            v-model="dataProrrogada"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataProrrogada.$touch()"
                        ></date-picker>
                    </b-input-group>
                </b-form-group>

                <b-form-group v-if="exibeValor">
                    <label>Valor do Aditivo</label>
                    <b-input-group>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                            :state="$v.valor.$error? false : null"
                        ></money>
                        <b-form-invalid-feedback>Valor Aditivo Obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>

                <b-form-group v-if="exibeDocumento">
                    <label>Arquivo</label>
                    <b-form-file
                        placeholder="Arquivo"
                        v-model="arquivo"
                        ref="arquivoInput"
                        :state="Boolean(arquivo)"
                    ></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        convenio: Object,
        aditivo: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        valor: {
            valorOk() {
                if (this.tipoAditivo == 2) {
                    return this.valor && this.valor > 0;
                }
                return true
            }
        },
        arquivo: {
            arquivoOk(){
                if (this.tipoAditivo == 3 || this.tipoAditivo == 4) {
                    return this.arquivo != null;
                }
                return true; 
            }
        },
        objeto: {
            required
        },
        dataProrrogada: {
            dataOk() {
                if (this.tipoAditivo == 1) {
                    return this.dataProrrogada && this.dataProrrogada.trim() !== '';
                }
                return true; 
            }
        },
    },

    data() {
        return {
            objeto: null,
            valor: 0,
            dataProrrogada: '',
            tipoAditivo:null,
            idAditivo: 0,
            exibeValor: false,
            exibeData: true,
            exibeDocumento: false,
            atualizar: false,
            idArquivo: null,
            arquivo:null,
            statusAditivo: 1,
            nomearquivo: '',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false,
            },
            tiposAditivo: [
                {
                    key: '1',
                    label: 'Alteração de vigência',
                },
                {
                    key: '2',
                    label: 'Acréscimo/Supressão',
                },
                {
                    key: '3',
                    label: 'Alteração do Plano de Trabalho',
                },
                {
                    key: '4',
                    label: 'Alteração das demais Cláusulas do Instrumento',
                }
            ]
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                if(this.aditivo.tipoAditivo == 1){
                    this.idAditivo = this.aditivo.idAditivo
                    this.tipoAditivo = this.aditivo.tipoAditivo
                    this.dataProrrogada = this.$moment(this.aditivo.dataProrrogada).format('DD/MM/YYYY')
                    this.valorAditivo = this.aditivo.valor
                    this.objeto = this.aditivo.objeto
                    this.valorAditivo = this.aditivo.valorAditivo
                    this.statusAditivo = this.aditivo.statusAditivo
                    this.atualizar = true
                    this.exibeValor = false
                    this.exibeData = true
                } else if (this.aditivo.tipoAditivo == 2){
                    this.idAditivo = this.aditivo.idAditivo
                    this.tipoAditivo = this.aditivo.tipoAditivo
                    this.dataProrrogada = this.$moment(this.aditivo.dataProrrogada).format('DD/MM/YYYY')
                    this.valor = this.aditivo.valorAditivo
                    this.objeto = this.aditivo.objeto
                    this.valorAditivo = this.aditivo.valorAditivo
                    this.statusAditivo = this.aditivo.statusAditivo
                    this.atualizar = true
                    this.exibeValor = true
                    this.exibeData = false
                } else if (this.aditivo.tipoAditivo == 3 || this.aditivo.tipoAditivo == 4){
                    this.idAditivo = this.aditivo.idAditivo
                    this.tipoAditivo = this.aditivo.tipoAditivo
                    this.dataProrrogada = this.$moment(this.aditivo.dataProrrogada).format('DD/MM/YYYY')
                    this.valor = this.aditivo.valorAditivo
                    this.objeto = this.aditivo.objeto
                    this.valorAditivo = this.aditivo.valorAditivo
                    this.statusAditivo = this.aditivo.statusAditivo
                    this.atualizar = true
                    this.exibeValor = false
                    this.exibeData = false
                    this.exibeDocumento = true
                }
            } else {
                this.dataAditivo = new Date()
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.dataAditivo = new Date()
            this.objeto = ""
            this.tipoAditivo = 1
            this.dataProrrogada = new Date()
            this.valorAditivo=0
            this.statusAditivo=1
            this.objeto= null
            this.valor= 0
            this.dataProrrogada= ''
            this.arquivo = null
            this.nomearquivo = ''
            this.idArquivo = null
            this.idAditivo = 0
            this.erros= []
            this.atualizar = false
        },

        confirmarSalvar(){
            this.$swal({
                title: 'Aditivo de convênio',
                html: `Confirma a inserção do aditivo?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let aditivoDto = {
                objeto: this.objeto,
                tipoAditivo: this.tipoAditivo,
                dataProrrogada: this.dataProrrogada,
                valorAditivo : this.valor,
                arquivo: this.arquivo,
                nomeArquivo: this.arquivo != null ? this.arquivo.name : '',
                idAditivo: this.idAditivo,
                statusAditivo: this.statusAditivo,
            }
            this.$emit('salvar', aditivoDto)
            this.resetar()
        },
    },

    watch: {
        tipoAditivo(){
            if(this.tipoAditivo){
                if(this.tipoAditivo == 1){
                    this.exibeValor = false
                    this.exibeData = true
                    this.exibeDocumento = false
                }
                else if(this.tipoAditivo == 2){
                    this.exibeValor = true
                    this.exibeData = false
                    this.exibeDocumento = false
                }
                else if(this.tipoAditivo == 3 || this.tipoAditivo == 4){
                    this.exibeValor = false
                    this.exibeData = false
                    this.exibeDocumento = true
                }
            }
        }
    }
}
</script>
